import { NavLink, useLocation } from 'react-router-dom';
import logo from '../assets/images/logo-locwire.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect } from 'react';

const nav = [
    { label: "Translate", link: "/translate" },
    { label: "Users", link: "/users" },
]
export default function Header() {
    const location = useLocation()
    const [showDD, setShowDD] = React.useState(false);
    useEffect(() => {
        setShowDD(false)
    }, [location.pathname])

    const logout = () => {
        localStorage.clear();
        window.location.href = "/login";
    }

    return (
        <header className='header'>
            <div className='container-fluid'>
                <div className='header_block'>
                    <div className='header_inner'>
                        <NavLink to={"/"}>
                            <img src={logo} alt='Locwire' width={100} />
                        </NavLink>
                        <div className='header_nav'>
                            <ul>
                                {nav.map((item, index) => (
                                    <li key={index}>
                                        <NavLink to={item.link}>{item.label}</NavLink>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className='header_account'>
                        <button className='btn rounded' onClick={() => setShowDD(!showDD)}>
                            <FontAwesomeIcon icon={faCog} />
                        </button>
                        {showDD ?
                            <div className='header_account_dropdown'>
                                <button className='logout' onClick={logout}>Logout</button>
                            </div>
                            : null
                        }
                    </div>
                </div>
            </div>
        </header>
    )
}
